export default __webpack_public_path__ + "static/media/illustration-study-3-w.f62dc8ae.webp";